export default {
  getSubjectsOfAStudent: '/timetable/getSubjectsOfAStudent',
  getTimetableSlotsOfAFaculty: '/timetable/getTimetableSlotsOfAFaculty'
}
